export default {
	Pending: 0,
	Complete: 1,
	Invalid: 2,
	Generate: 3,
	Lodged: 3
};
